
export default {
  "header": {
    "title": "System Title",
    "welcome": "Welcome back"
  },
  //首页
  "产品":"Products",
  "定价":"Pricing",
  "资源中心":"Resource Center",
  "关于我们":"About Us",
}


// WEBPACK FOOTER //
// ./src/lang/en.js